import ReceiptsComponent from "./Payment/Receipts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";

export default function Receipts() {
  return (
    <Card>
      <CardHeader className="border-b border-border">
        <CardTitle>Histórico de pagamentos</CardTitle>
        <CardDescription>
          Visualize todos os seus recibos de recargas realizadas e pendentes. Mantenha o controle
          completo de suas transações na plataforma Maritaca AI.
        </CardDescription>
      </CardHeader>
      <CardContent className="p-5">
        <ReceiptsComponent />
      </CardContent>
    </Card>
  );
}
